import { atom } from 'jotai';
import type { z } from 'zod';

import type { attachmentDataSchema } from './channel/channel-attachment';

/**
 * 세컨솔드 채팅 UI Atom.
 */
export const aclosetChatStore = atom<{
  /**
   * 채팅방 열기/닫기.
   */
  open: boolean;

  currentChannel: {
    /**
     * 선택된 채팅방 주소.
     */
    url: string;

    /**
     * 채팅방에 첨부된 데이터.
     */
    attachment?: z.output<typeof attachmentDataSchema>;
  };
}>({
  open: false,

  currentChannel: {
    url: '',
  },
});
